import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationReasonMissingProtocolModel } from '@evorait/pace-core';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-confirmation-reason-missing-protocol',
    templateUrl: './confirmation-reason-missing-protocol.component.html',
    styleUrls: ['./confirmation-reason-missing-protocol.component.scss'],
})
export class ConfirmationReasonMissingProtocolComponent implements OnInit {
    @Input() public model: ConfirmationReasonMissingProtocolModel;
    public documentReasonForm: FormGroup;
    public formChildren: FormArray;
    public modalResult = new Subject<boolean>();

    public strings: {
        applyLabel: string;
        paceFormsQuickAccessLabel: string;
    };

    public constructor(
        public readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly translate: TranslateService,
    ) {
        this.strings = {
            applyLabel: <string>(
                this.translate.instant('CONFIRMATION_DOCUMENT_REASON_FOR_MISSING_PROTOCOLS_APPLY_LABEL')
            ),
            paceFormsQuickAccessLabel: <string>this.translate.instant('CONFIRMATION_PACE_FORMS_LABEL'),
        };
    }

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.documentReasonForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
    }

    public onNavigateToPaceForms(): void {
        this.model.reasonSelected = undefined;
        this.model.reasonForMissingProtocols.deselect();
        this.modalResult.next(false);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public applyDocumentedReason(): void {
        this.modalResult.next(true);
        this.modalResult.complete();
        this.modalInstance.hide();
    }

    public closeModal(): void {
        this.model.reasonForMissingProtocols.deselect();
        this.modalResult.complete();
        this.modalInstance.hide();
    }
}
